'use client';

import { useCallback } from 'react';

const DownArrow = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="50"
        height="50"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#ff6900"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="animate-bounce"
        aria-hidden="true"
    >
        <path d="M6 9l6 6 6-6" />
    </svg>
);

const HeroScrollButton = () => {
    const handleScroll = useCallback((event) => {
        event.preventDefault();

        const button = event.currentTarget;
        const heroSection = button.closest('section');
        const sections = Array.from(
            document.querySelectorAll('section'),
        ).filter(
            (section) =>
                section.getAttribute('aria-label') !== 'Site announcement',
        );

        const currentIndex = sections.indexOf(heroSection);
        const preferredIndex = currentIndex >= 0 ? currentIndex + 1 : 1;
        const fallbackIndex = sections.length > 1 ? 1 : 0;
        const targetSection =
            sections[preferredIndex] || sections[fallbackIndex];

        if (!targetSection) return;
        const targetRect = targetSection.getBoundingClientRect();
        const navRect = document
            .getElementById('navbar')
            ?.getBoundingClientRect();
        const offset = navRect ? navRect.top + navRect.height : 80;
        const sectionTop = targetRect.top + window.pageYOffset - offset;

        window.scrollTo({ top: sectionTop, behavior: 'smooth' });
    }, []);

    return (
        <button
            type="button"
            className="absolute bottom-2 md:bottom-8 left-1/2 transform -translate-x-1/2 text-white hover:text-gray-200 focus:outline-none cursor-pointer transition-colors"
            aria-label="Scroll to next section"
            onClick={handleScroll}
        >
            <DownArrow />
        </button>
    );
};

export default HeroScrollButton;
